import TabGrid from "components/cards/TabCardGrid.js";
import DownloadApp from "components/cta/DownloadApp.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import MainFeature3 from "components/features/TwoColWithTwoFeaturesAndButtons.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Testimonial from "components/testimonials/TwoColumnWithImage.js";
import Testimonial1 from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import FAQ from "components/faqs/TwoColumnPrimaryBackground"

import celebrationIconImageSrc from "images/celebration-icon.svg";
import chefIconImageSrc from "images/chef-icon.svg";
import shopIconImageSrc from "images/shop-icon.svg";

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  // const HighlightedText = tw.span`bg-black text-gray-900 transform -skew-x-12 inline-block`;
  const HighlightedText = tw.span`font-bold text-gray-700`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block font-thin`;
  const imageCss = tw`border-white`;
  return (
    <AnimationRevealPage>
      <Hero
        heading={<>Nowy wymiar handlu. Zero pomyłek. Pełna automatyzacja.</>}
        description={
          <Description>
            Dostarczamy innowacyjne i kompleksowe systemy, które w całości opieramy na naszym autorskim oprogramowaniu. Dzięki temu, że pracujemy na własnych rozwiązaniach, mamy pełną kontrolę nad ich rozwojem i możemy elastycznie dostosować system do specyficznych potrzeb Twojego biznesu.
            <br></br>
            Wybierając e-Cenówki, zyskujesz nie tylko sprzęt, ale przede wszystkim bezpieczeństwo i ciągłość pracy. Nasz zespół ekspertów zapewnia pełne zdalne wsparcie użytkownika – błyskawicznie reagujemy na zgłoszenia, przeprowadzamy zdalne aktualizacje i pomagamy w bieżącej obsłudze bez konieczności wizyty w Twoim punkcie.
            {/* Serwis do zdalnego zarządzania elektronicznymi etykietami cenowymi (ESL) to zaawansowane oprogramowanie umożliwiające centralne zarządzanie, monitorowanie i aktualizowanie etykiet cenowych w różnych lokalizacjach, często w czasie rzeczywistym. Tego typu serwis jest niezbędny w dużych sieciach detalicznych, aptekach, inteligentnych biurach czy magazynach, gdzie zmiana cen, promocji czy dostępności produktów wymaga szybkiej i efektywnej reakcji. Dzięki integracji z systemami ERP, POS oraz innymi technologiami, takie rozwiązania oferują wysoką efektywność, elastyczność i dokładność, co pozwala na osiągnięcie znacznych oszczędności operacyjnych i poprawę doświadczeń klientów. */}
            {/* Serwis SaaS do zdalnego zarządzania ekspozycją w wielu placówkach w jednym czasie. 
            Zintegrowany z elektronicznymi etykietami cenowymi (ESL) oraz lokalnym systemem sprzedażowym automatycznie aktualizuje informacje o produktach na półkach. Etykiety wykonane są w technologii e-papieru i są ekologiczną odpowiedzią na ekrany LED-owe ponieważ pobierają zdecydowanie mniej energii.
            Wyświetlacz wykonany w wysokiej rozdzielczości. Szeroki wybór rozmiarów. Wdrożenia w chmurze lub on premieses, możliwa integracja API. Indywidualne wyceny. */}
          </Description>
        }
        imageSrc="IMG_0269.jpg"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        primaryButtonText="Skontaktuj się z nami"
        primaryButtonUrl="#Kontakt"
        watchVideoButtonText="Zobacz film"
      />
      <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Zdalne zarządzanie półkami w całej sieci.
            {/* <HighlightedText> Detaliczna</HighlightedText> */}
            <wbr />
          </>
        }
        description={
          <Description>
            Zapewnienie spójności wizualnej i realizacja strategii merchandisingowej w kilkunastu, kilkudziesięciu czy setkach placówek handlowych to ogromne wyzwanie logistyczne. Dzięki integracji e-cenówek z funkcją zarządzania planogramami możesz kontrolować przestrzeń półkową bez wychodzenia z biura.
            <br></br><br></br>
            <HighlightedText>Jak to działa w praktyce?</HighlightedText>
            <br></br>
            System automatycznie łączy dane o lokalizacji produktu na półce z wyświetlaczem e-cenówki. Tworząc lub modyfikując planogram w centrali, zmiany są natychmiastowo mapowane w wybranych sklepach.
            {/* <HighlightedText>1. AUTOMATYZACJA</HighlightedText> - 
            Błyskawiczna zmiana cen w całej sieci sklepów. Automatyczne wyliczanie cen jednostkowych, dyrektywa Omnibus.<br></br>
            <HighlightedText>2. BEZPIECZEŃSTWO</HighlightedText> - 
            Zgodność ceny na półce z ceną przy kasie.<br></br>
            <HighlightedText>3. DYNAMICZNE CENY</HighlightedText> - 
            Zmiany cen w zależności od pory dnia czy stanów.<br></br>
            <HighlightedText>4. EKOLOGIA</HighlightedText> -
            Eliminacja ton papieru i tonerów zużywanych na tradycyjne cenówki.<br></br>
            <HighlightedText>5. TRWAŁOŚĆ</HighlightedText> - 
            Bateria wytrzymująca do 10 lat ciągłej pracy e-cenówki.<br></br>
            <HighlightedText>6. SKALOWALNOŚĆ</HighlightedText> - 
            System idealny dla małych sklepów i wielkich hipermarketów. */}

            {/* Elektroniczne etykiety cenowe (ESL – Electronic Shelf Labels) w branży detalicznej to innowacyjne rozwiązanie, które zyskuje coraz większą popularność w sklepach stacjonarnych, sieciach handlowych oraz supermarketach. Etykiety te są stosowane na półkach, gdzie wyświetlają ceny produktów, a także dodatkowe informacje, takie jak promocje, dostępność towaru, skład czy inne dane dotyczące towaru. Zamiast tradycyjnych papierowych etykiet, które wymagają manualnej wymiany i aktualizacji, ESL działają w sposób zautomatyzowany, co niesie za sobą wiele korzyści. */}
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej inforamcji >>"
        primaryButtonUrl="#ESL_w_branzy_detalicznej"
        imageSrc="Gemini33.png"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Proces cyfryzacji w 4 prostych krokach.
            {/* <HighlightedText> Detaliczna</HighlightedText> */}
            <wbr />
          </>
        }
        description={
          <Description>
            <HighlightedText>KROK 1 - Audyt i Projekt</HighlightedText><br></br>
            Analizujemy Twoją przestrzeń i wspólnie dobieramy optymalne rozmiary wyświetlaczy.<br></br>
            <HighlightedText>KROK 2 - Personalizacja</HighlightedText><br></br>
            Przygotowujemy spersonalizowane szablony dla e-cenówek zgodnie z wytycznymi.<br></br>
            <HighlightedText>KROK 3 - Montaż</HighlightedText><br></br>
            Instalujemy infrastrukturę sprzętową i integrujemy system z Twoim ERP/POS.<br></br>
            <HighlightedText>KROK 4 - Obsługa i Wsparcie</HighlightedText><br></br>
            Zapewniamy ciągłość działania i zdalną pomoc techniczną.<br></br>
            {/* <HighlightedText>5. KLUCZOWE WSKAŹNIKI ROI</HighlightedText> - 
            Koszty operacyjne personelu: - 70%, poprawność cen na półkach: 100%.<br></br> */}

            {/* Elektroniczne etykiety cenowe (ESL – Electronic Shelf Labels) w branży detalicznej to innowacyjne rozwiązanie, które zyskuje coraz większą popularność w sklepach stacjonarnych, sieciach handlowych oraz supermarketach. Etykiety te są stosowane na półkach, gdzie wyświetlają ceny produktów, a także dodatkowe informacje, takie jak promocje, dostępność towaru, skład czy inne dane dotyczące towaru. Zamiast tradycyjnych papierowych etykiet, które wymagają manualnej wymiany i aktualizacji, ESL działają w sposób zautomatyzowany, co niesie za sobą wiele korzyści. */}
          </Description>
        }
        buttonRounded={false}
        textOnLeft={true}
        primaryButtonText="Więcej inforamcji >>"
        primaryButtonUrl="#ESL_w_branzy_detalicznej"
        imageSrc="Gemini6.png"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Koszt i warianty finansowania.
            {/* <HighlightedText> Farmaceutyczna</HighlightedText> */}
            <wbr />
          </>
        }
        description={
          <Description>
            Koszt wdrożenia systemu ESL jest ściśle uzależniony od liczby oraz wielkości etykiet. Aby otrzymać wstępną wycenę dla Twojego obiektu skontaktuj się z nami bezpośrednio – przygotujemy kalkulację dopasowaną do Twojej skali działalności. 
            <br></br><br></br>
            Przykładowy koszt zestawu 100 szt. e-Cenówek 2.13'' wraz z centralą to <HighlightedText>4042 zł netto + 23%VAT.</HighlightedText> 
            <br></br>
            Do tej kwoty należy dodać jeszcze koszt mocowania (listwy, klipsy lub listwy magnetyczne). 
            <br></br><br></br>
            Oferujemy naszym Klientom sprzedaż ratalną: 2, 4, 6 lub 12 rat.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej inforamcji >>"
        primaryButtonUrl="#ESL_w_aptekach"
        imageSrc="Gemini5.png"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      {/* <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Biura
            <HighlightedText> Biura</HighlightedText>
            <wbr />
          </>
        }
        description={
          <Description>
            Elektroniczne etykiety cenowe (ESL) w inteligentnych biurach to innowacyjne rozwiązanie, które wychodzi poza tradycyjny kontekst handlowy, znajdując zastosowanie w nowoczesnych przestrzeniach biurowych. Chociaż systemy ESL są najczęściej kojarzone z branżą detaliczną, to w inteligentnych biurach ich implementacja może przynieść szereg korzyści, zarówno z perspektywy zarządzania przestrzenią, jak i optymalizacji procesów.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej inforamcji >>"
        primaryButtonUrl = "#ESL_w_biurach"
        imageSrc="sciezka.png"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      /> */}
      {/* <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Magazyny
            <HighlightedText>Magazyny</HighlightedText>
            <wbr />
          </>
        }
        description={
          <Description>
            Elektroniczne etykiety cenowe (ESL) w magazynach to nowoczesne rozwiązanie, które znacząco wykracza poza tradycyjne zastosowania w handlu. W środowisku magazynowym technologia ESL otwiera zupełnie nowe możliwości w zakresie automatyzacji, efektywnego zarządzania stanami oraz usprawnienia procesów logistycznych. Dzięki cyfrowym etykietom możliwe jest dynamiczne oznaczanie lokalizacji, szybka aktualizacja danych operacyjnych oraz pełna synchronizacja informacji z systemami WMS.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej inforamcji >>"
        primaryButtonUrl = "#ESL_w_magazynach"
        imageSrc="roi.png"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      /> */}
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      {/* <Testimonial1
        subheading=""
        heading={<>Poznaj opnie <HighlightedText>naszych Klientów.</HighlightedText></>}
      />  */}
      
      {/* <TabGrid
        heading={
          <>
            Modele <HighlightedText>i rozmiary:</HighlightedText>
          </>
        }
      /> */}
      {/* <Features
        heading={
          <>
            Dostarczamy <HighlightedText>Branze.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "230+ Locations",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com"
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Professional Chefs",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://timerse.com"
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Birthday Catering",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://reddit.com"
          }
        ]}

        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      /> */}
        {/* <MainFeature
        subheading={<Subheading></Subheading>}
        heading={<>Koszt i warianty finansowania.<HighlightedText></HighlightedText></>}
        description ={"Koszt wdrożenia systemu ESL jest ściśle uzależniony od liczby oraz wielkości etykiet. Aby otrzymać wstępną wycenę dla Twojego obiektu skontaktuj się z nami bezpośrednio – przygotujemy kalkulację dopasowaną do Twojej skali działalności. Przykładowy koszt zestawu 100 szt. e-Cenówek 2.13'' wraz z centralą to 4042 zł netto + 23%VAT. Do tej kwoty należy dodać jeszcze koszt mocowania (listwy, klipsy lub listwy magnetyczne). Oferujemy Klientom sprzedaż ratalną - 2, 4, 6 lub 12 rat."}
        statistics={[
          {
            key: "",
            value: ""
          },
          {
            key: "",
            value: ""
          },
          {
            key: "",
            value: ""
          }
        ]}
        primaryButtonText="Zamów bezpłatną wycenę"
        primaryButtonUrl="#Kontakt"
        imageInsideDiv={false}
        imageSrc="Gemini5.png"
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={false}
      /> */}

      <TabGrid
        heading={
          <>
            Modele i rozmiary:
          </>
        }
      />

      <FAQ></FAQ>

      {/* <Testimonial1
        subheading=""
        heading={<>Opinie osób, które pożegnały papierowe etykiety i wybrały pełną automatyzację.</>}
      />  */}
      <Testimonial
        subheading=""
        heading={<>Opinie Klientów.</>}
      /> 

      <MainFeature3
        subheading={<Subheading></Subheading>}
        heading={<>Twój partner w cyfrowej transformacji.</>}
        description ={"Dostarczamy innowacyjne oraz kompleksowe rozwiązania informatyczne. Nasze wieloletnie doświadczenie, kreatywność i poświęcenie pozwala wyróżnić naszą firmę na rynku usług informatycznych. Skontaktuj się z nami, aby dowiedzieć się jak możemy wspomóc działalność Twojej firmy."}
        statistics={[
          {
            key: "Doświadczenie",
            value: "20 lat"
          },
          {
            key: "Klienci",
            value: "100+"
          },
          {
            key: "Serwisy",
            value: "3+"
          }
        ]}
        primaryButtonText="Wejdź na stronę Datagrit"
        primaryButtonUrl="https://datagrit.pl"
        imageInsideDiv={false}
        //imageSrc="IMG_0396.jpg"
        imageCss={Object.assign(tw`rounded-2xl bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={true}
      />

      {/* <DownloadApp
        text={<>People around you are ordering delicious meals using the <HighlightedTextInverse>Treact App.</HighlightedTextInverse></>}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
}
